import { TeamsService } from '@teams/infra';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GetTeamMemberCandidatesPathParams, GetTeamMemberCandidatesResponse, TeamMemberCandidateDto } from '@core-http';
import { GetTeamCandidatesQueryResult, TeamCandidate } from './get-team-candidates.query-result';

export class GetTeamCandidatesQueryHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  candidates(teamId: string): Observable<GetTeamCandidatesQueryResult> {
    const pathParams: GetTeamMemberCandidatesPathParams = { teamId };

    return this.teamsService
      .getCandidates(pathParams)
      .pipe(map((dto: GetTeamMemberCandidatesResponse) => this.mapToQueryResult(dto)));
  }

  private mapToQueryResult(dto: GetTeamMemberCandidatesResponse): GetTeamCandidatesQueryResult {
    return {
      availableToInvite: dto.availableToInvite.map((candidate: TeamMemberCandidateDto): TeamCandidate => {
        return {
          userId: candidate.userId,
          displayName: candidate.displayName,
          thumbnail: candidate.thumbnail,
          gamesPlayed: candidate.gamesPlayed
        };
      })
    };
  }
}
